export default [
  "$stateProvider",
  "$urlRouterProvider",
  function ($stateProvider, $urlRouterProvider) {
    // Now set up the states
    $stateProvider.state("knowYourCustomerAdmin", {
      parent: "app",
      url: "/administration/kyc?&handledManually&customerId&dataFromDot.riskClassAuto&dataFromDot.riskClassManual&dataStage.dataStageCode&dataStage.changedAtFrom&dataStage.changedAtUntil&dataStage.userName&dataFromCustomer.pepChecked&dataFromCustomer.overallCitizenshipRisk&dataFromCustomer.jobAddressRisk&dataFromCustomer.jobPositionType&dataFromCustomer.incomeFrom&dataFromCustomer.incomeUntil&dataFromDot.cardLastLockDateFrom&dataFromDot.cardLastLockDateUntil&numUploads&dataFromDot.riskNextCheckDateFrom&dataFromDot.riskNextCheckDateUntil&dataFromDot.riskLastCheckDateFrom&dataFromDot.riskLastCheckDateUntil&downloadError",
      views: {
        main: {
          template: require("./eaKnowYourCustomerAdministrationPage/eaKnowYourCustomerAdministrationPageModule.html"),
          controller:
            "eaKnowYourCustomerAdministrationPageModuleController as $ctrl",
        },
      },
      resolve: {
        ctrl: [
          "$q",
          "$ocLazyLoad",
          ($q, $ocLazyLoad) => {
            return $q((resolve) => {
              require.ensure([], () => {
                let module = require("./index.js");
                $ocLazyLoad.load({ name: module.default });
                resolve();
              });
            });
          },
        ],
      },
    });
    $stateProvider.state("knowYourCustomerAdminCapturePage", {
      parent: "app",
      url: "/administration/kycCapture?id",
      views: {
        main: {
          template: require("./eaKnowYourCustomerCaptureFormPage/eaKnowYourCustomerCaptureFormPageModule.html"),
          controller:
            "eaKnowYourCustomerCaptureFormPageModuleController as $ctrl",
        },
      },
      resolve: {
        ctrl: [
          "$q",
          "$ocLazyLoad",
          ($q, $ocLazyLoad) => {
            return $q((resolve) => {
              require.ensure([], () => {
                let module = require("./index.js");
                $ocLazyLoad.load({ name: module.default });
                resolve();
              });
            });
          },
        ],
      },
    });
  },
];



// WEBPACK FOOTER //
// ./src/ui/modules/eaAdministration/eaKnowYourCustomer/routes.js